<template>
  <div>
    <div class="d-flex justify-content-between font-responsive-small">
      <label class="-small-caps m-b-0">{{
        event.EventType || eventType[event.EventTypeId]
      }}</label>
      <div v-if="event.Restrictions && event.Restrictions.length">
        <div
          v-for="(group, index) in event.Restrictions"
          :key="`restricion-${index}`"
          :class="{ '-gray-dark': !highlight }"
        >
          {{ restrictions[group.LoyaltyGroupId] }}
        </div>
      </div>
      <div v-else-if="isInvite" :class="{ '-gray-dark': !highlight }">
        {{ insertString("Event", "InviteOnly") }}
      </div>
      <div v-else :class="{ '-gray-dark': !highlight }">
        {{ insertString("Event", "OpenForAll") }}
      </div>
    </div>
    <div class="font-responsive-body">
      <div class="-bold m-t-3 m-t-md-6" :class="{ '-ellipsis': !showAll }">
        {{ overrideTitle || event.Title }}
      </div>
      <EventDate
        :from="event.Start"
        :to="event.End"
        :approximate="event.IsApproximateDate"
      />
      <div class="d-flex justify-content-between align-items-end">
        <div class="-ellipsis -thin" v-html="locationName" />
        <div
          v-if="!compact"
          class="font-responsive-small"
          :class="{ '-gray-dark': !highlight }"
          style="margin-bottom: 2px; white-space: nowrap"
          v-html="spotsLeftOutput"
        />
      </div>
    </div>
    <div
      v-if="
        showAll &&
        (event.MinimumAge || event.DifficultyLevel > 0 || event.LanguageId)
      "
      class="font-responsive-small"
    >
      <hr />
      <div v-if="event.MinimumAge">
        {{ insertString("Event", "MinimumAgeLabel") }}: {{ event.MinimumAge }}
      </div>
      <div v-if="event.DifficultyLevel > 0">
        {{ insertString("Event", "LevelLabel") }}:
        {{ insertString("Event", "Level", getLevel(event.DifficultyLevel)) }}
      </div>
      <div v-if="event.LanguageId">
        {{ insertString("Event", "LanguageLabel") }}:
        {{ insertString("Event", "Language", event.LanguageId) }}
      </div>
    </div>
  </div>
</template>
<script>
import EventDate from '@/Scripts/components/pages/Content/Events/Assets/EventDate.vue';
export default {
  components: {
    EventDate
  },
  props: {
    event: Object,
    overrideTitle: String,
    compact: Boolean,
    showAll: Boolean,
    userEventIds: Array,
    highlight: Boolean

  },
  computed: {
    isInvite () {
      return this.event && this.event.InvitationOnly;
    },
    locationName () {
      let locationOverrideName = this.event.Location || this.event.LocationCity;
      if (this.event && typeof this.event.Location === 'object' && this.event.Location !== null) {
        locationOverrideName = this.event.Location.Name || this.event.Location.City;
      }
      return locationOverrideName || this.event.storeName || '&nbsp;';
    },

    spotsLeft () {
      let left = this.event.MaximumSpots - this.event.Attending;
      if (left < 0) {
        left = 0;
      }
      return left;
    },
    spotsLeftOutput () {
      if (this.event.MaximumSpots === null) {
        return '&nbsp;';
      }
      return `${this.spotsLeft} ${this.insertString('Event', this.spotsLeft === 1 ? 'SpotLeft' : 'SpotsLeft')}`;
    },
    waitingListLeft () {
      return this.event.MaximumWaitingList - this.event.Waiting;
    },
    eventType () {
      return {
        auction: 'Auction',
        christmascalendar: 'Christmas calendar',
        competition: 'Competition',
        howtocourse: 'How-to course',
        innature: 'In-nature',
        instore: 'In Store',
        online: 'Online',
        productlaunch: 'Product launch',
        producttesting: 'Product testing'
      };
    },
    restrictions () {
      return {
        1: 'Loyalty only',
        3: 'Ambassador',
        4: 'Employee',
        7: 'Employee Norway',
        10: 'Employee Retail',
        9: 'Employee Retail Norway',
        6: 'Partner',
        2: 'Pro user',
        12: 'Wholesale Canada',
        11: 'Wholesale US'
      };
    }
  },
  methods: {
    getLevel (id) {
      return {
        1: 'beginner',
        2: 'intermediate',
        3: 'expert'
      }[id];
    }
  }
};
</script>
